import { TitleCasePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AuthInterceptor } from 'src/app/core/interceptors/auth.interceptor';
import { SimulationManagerService } from 'src/app/core/services/simulation/simulation-manager.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TOASTR } from './core/constants/toastr';
import { AuthService } from './core/services/auth/auth.service';
import { CatenaryService } from './core/services/catenary/catenary.service';
import { FlexLineImporterService } from './core/services/fraes/flex-line-importer.service';
import { SimulationResultsDownloadService } from './core/services/simulation/download/simulation-results-download.service';
import { SharedModule } from './shared/shared.module';
import { JsonCleanerService } from './shared/utils/json-cleaning/json-cleaner.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({ positionClass: TOASTR.POSITION }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthService,
    SimulationManagerService,
    CatenaryService,
    JsonCleanerService,
    SimulationResultsDownloadService,
    FlexLineImporterService,
    TitleCasePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
